import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import { KpiDetailsInterface } from '../common/components/FullKpiGrid/types';

export type EntityKpiDetailsInitialState = {
  entityKpiDetails: KpiDetailsInterface[];
  errorMessage: string;
};

export const initialState: EntityKpiDetailsInitialState = {
  entityKpiDetails: [],
  errorMessage: '',
};

export const entityKpiDetailsSlice = createSlice({
  name: 'entityKpiDetails',
  initialState,
  reducers: {
    getEntityKpiDetailsSuccess: (
      state,
      action: PayloadAction<KpiDetailsInterface[]>,
    ) => {
      state.entityKpiDetails = action.payload;
      state.errorMessage = '';
    },
    getEntityKpiDetailsError: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
      state.entityKpiDetails = [];
    },
    clearEntityKpiDetails: (state) => {
      state.entityKpiDetails = [];
      state.errorMessage = '';
    },
  },
});

export const getEntityKpiDetailsAction = createAction<{ entityId: string }>(
  'entityKpiDetails/getEntityKpiDetails',
);

export const {
  getEntityKpiDetailsSuccess,
  getEntityKpiDetailsError,
  clearEntityKpiDetails,
} = entityKpiDetailsSlice.actions;

export const entityKpiDetailsSelectors = {
  selectEntityKpiDetails: (state: RootState) =>
    state.entityKpi.entityKpiDetails,
};

export default entityKpiDetailsSlice.reducer;
